<template>
  <div class="l-edit-dialog-box" style="max-height: 75vh; height: 75vh;">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="top" v-loading="loading" class="l-edit-dialog-box-label">
      <el-row :gutter="30">
        <el-col :span="6">
          <el-form-item label="考试名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入考试名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="考试发布人" prop="initiator">
            <el-input v-model="form_data.initiator" autocomplete="off" placeholder="请输入考试发布人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="题目归属模块" prop="subject_name">
            <el-select v-model="form_data.subject_name" placeholder="请选择题目类型" @change="changes">
              <el-option v-for="item in options" :key="item.id" :label="item.value1" :value="item.cust_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="考试时长" prop="duration">
            <el-input-number v-model="form_data.duration" :min="1" :max="180" label="考试时长"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="数量（单选/多选/判断）" prop="combined_type">
            <el-row :gutter="30">
              <el-col :span="6" v-for="(item,index) in form_data.combined_type" :key="index">
                <el-input-number v-model="form_data.combined_type[index]" :min="0" :max="180" label="数量"></el-input-number>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="分数（单选/多选/判断）" prop="combined_scoring">
            <el-row :gutter="30">
              <el-col :span="6" v-for="(item,index) in form_data.combined_scoring" :key="index">
                <el-input-number v-model="form_data.combined_scoring[index]" :min="0" :max="10" label="分数"></el-input-number>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="题目总数" prop="sum_subject">
            <el-input-number v-model="form_data.sum_subject" :min="0" :max="100" label="总数"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总分" prop="scoring">
            <el-input-number v-model="form_data.scoring" :min="0" :max="150" label="总分"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24"></el-col>
        <el-col :span="6">
          <el-form-item label="报名时间" prop="train_time">
            <div class="block">
              <el-date-picker v-model="form_data.train_time" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结束时间" prop="end_time">
            <div class="block">
              <el-date-picker v-model="form_data.end_time" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="状态">
            <el-switch v-model="form_data.is_start" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="2">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'l-test-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {},
      subject_s: "",
      options: [],
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '题目内容不能为空', trigger: 'change' }
        ],
        initiator: [
          { required: true, message: '选项A不能为空', trigger: 'change' }
        ],
        train_time: [
          { required: true, message: '报名时间不能为空', trigger: 'change' }
        ],
        end_time: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ]
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  methods: {
    changes() {
      this.subject_s = this.form_data.subject_name
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    //获取表格数据
    getTableData() {
      this.loading = true
      this.$_invoke(`examination_getData`, { id: this.$props.id }).then((ret) => {
        this.form_data = ret.date;
        this.options = ret.type_name;
        this.subject_s = this.form_data.subject_superior
      }).finally(() => {
        this.loading = false;
      });
    },
    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$_invoke('examination_update', {
            ...this.form_data,
            subject_s: this.subject_s
          }).then(() => {
            this.$_msg.success('编辑成功');
            this.$emit('on-success');
          }).finally(() => {
            this.submitting = false;
          })
        }
      })

    },
  },
}
</script>
